import { useTranslation } from '@ufc/core'
import {
  MapPin,
  Badge,
  TenantCell,
  cn,
} from '@ufc/uikit'
import { statusConfig } from '../constants'
import type { ShipmentCardProps } from '../types'

export function ShipmentCard({ shipment, showTenantColumn, onClick, isArabic }: ShipmentCardProps) {
  const { t } = useTranslation()
  const config = statusConfig[shipment.status]
  const StatusIcon = config.icon

  return (
    <div
      className="glass-card rounded-2xl overflow-hidden hover:shadow-xl transition-[box-shadow,border-color] duration-300 cursor-pointer"
      onClick={onClick}
    >
      <div className={cn(`bg-gradient-to-r ${config.gradient} p-4`, isArabic && "bg-gradient-to-l")}>
        <div className="flex items-center justify-between">
          <div className="flex-1 min-w-0">
            <p className="text-white/70 text-xs font-medium">{shipment.shipmentNumber}</p>
            <p className="text-white font-bold text-sm">{shipment.orderNumber}</p>
          </div>
          <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center">
            <StatusIcon className="w-5 h-5 text-white" />
          </div>
        </div>
      </div>
      <div className="p-4 space-y-3">
        <div>
          <p className="text-foreground font-medium text-sm">
            {isArabic ? shipment.product.ar : shipment.product.en}
          </p>
          <p className="text-muted-foreground text-xs">
            {shipment.quantity.value} {shipment.quantity.unit}
          </p>
        </div>
        {showTenantColumn && shipment.tenant && (
          <TenantCell tenant={shipment.tenant} />
        )}
        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center gap-1.5">
            <MapPin className="w-3.5 h-3.5 text-muted-foreground" />
            <span className="text-muted-foreground">{shipment.origin}</span>
          </div>
          <span className="text-muted-foreground/50">→</span>
          <div className="flex items-center gap-1.5">
            <MapPin className="w-3.5 h-3.5 text-primary" />
            <span className="text-foreground">{shipment.destination}</span>
          </div>
        </div>
        <div className="flex items-center justify-between pt-2 border-t border-border/50">
          <Badge className={cn(config.bg, config.text, "border-0 text-xs flex items-center gap-1.5")}>
            <StatusIcon className="w-3 h-3" />
            {t(`shipments.${shipment.status}`)}
          </Badge>
          <span className="text-xs text-muted-foreground">
            ETA: {shipment.eta || '-'}
          </span>
        </div>
      </div>
    </div>
  )
}
